import { escapeRegExp } from "lodash";
import { ReactNode } from "react";

import { Highlight } from "../../../../../common";

export const decorateWithMark = (
  text: string,
  searchValue: string,
): ReactNode => {
  const regex = new RegExp(`(${escapeRegExp(searchValue)})`, "i");
  const match = text.match(regex);

  if (!match) {
    return text;
  }

  const matchStartPosition = match.index as number;
  const matchEndPosition = matchStartPosition + match[0].toString().length;
  const startPart = text.slice(0, matchStartPosition);
  const endPart = text.slice(matchEndPosition, text.length);

  // Return a single tree node — an array of elements triggers React "missing key" in consumers (e.g. NumberCellTemplate).
  return (
    <>
      {startPart}
      <Highlight>{searchValue}</Highlight>
      {endPart}
    </>
  );
};
